var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoMini(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 59,
    viewBox: "0 0 72 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.557 40.3291L26.1121 28.5687L18.07 11.2025H0.189941L14.8146 40.3291H31.557Z",
    fill: "url(#paint0_linear_652_8057)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8354 59H40.7381L69.6456 0H52.1377L24.8354 59Z",
    fill: "url(#paint1_linear_652_8057)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.8027 59L71.8861 11.2025L65.8082 11.2236L42.7595 59H48.8027Z",
    fill: "url(#paint2_linear_652_8057)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_652_8057",
    x1: 6.93429,
    y1: 31.91,
    x2: 36.0674,
    y2: 53.6597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#69D5E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#6EDFCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72E9B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_652_8057",
    x1: 59.3271,
    y1: 23.3495,
    x2: 46.4891,
    y2: 79.2682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#69D5E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#6EDFCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72E9B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_652_8057",
    x1: 47.6301,
    y1: 44.836,
    x2: 83.3773,
    y2: 59.9365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#69D5E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#6EDFCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72E9B0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMini);
export default __webpack_public_path__ + "static/media/logo-mini.9390e09935fd7fe823058d642c3e2750.svg";
export { ForwardRef as ReactComponent };